!function (e, a) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = a() : "function" == typeof define && define.amd ? define(a) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.lkt = a());
}(this, function () {
  "use strict";

  return [{
    locale: "lkt",
    pluralRuleFunction: function pluralRuleFunction(e, a) {
      return "other";
    },
    fields: {
      year: {
        displayName: "Ómakȟa",
        relative: {
          0: "Lé ómakȟa kiŋ",
          1: "Tȟokáta ómakȟa kiŋháŋ",
          "-1": "Ómakȟa kʼuŋ héhaŋ"
        },
        relativeTime: {
          future: {
            other: "Letáŋhaŋ ómakȟa {0} kiŋháŋ"
          },
          past: {
            other: "Hékta ómakȟa {0} kʼuŋ héhaŋ"
          }
        }
      },
      "year-short": {
        displayName: "Ómakȟa",
        relative: {
          0: "Lé ómakȟa kiŋ",
          1: "Tȟokáta ómakȟa kiŋháŋ",
          "-1": "Ómakȟa kʼuŋ héhaŋ"
        },
        relativeTime: {
          future: {
            other: "Letáŋhaŋ ómakȟa {0} kiŋháŋ"
          },
          past: {
            other: "Hékta ómakȟa {0} kʼuŋ héhaŋ"
          }
        }
      },
      month: {
        displayName: "Wí",
        relative: {
          0: "Lé wí kiŋ",
          1: "Tȟokáta wí kiŋháŋ",
          "-1": "Wí kʼuŋ héhaŋ"
        },
        relativeTime: {
          future: {
            other: "Letáŋhaŋ wíyawapi {0} kiŋháŋ"
          },
          past: {
            other: "Hékta wíyawapi {0} kʼuŋ héhaŋ"
          }
        }
      },
      "month-short": {
        displayName: "Wí",
        relative: {
          0: "Lé wí kiŋ",
          1: "Tȟokáta wí kiŋháŋ",
          "-1": "Wí kʼuŋ héhaŋ"
        },
        relativeTime: {
          future: {
            other: "Letáŋhaŋ wíyawapi {0} kiŋháŋ"
          },
          past: {
            other: "Hékta wíyawapi {0} kʼuŋ héhaŋ"
          }
        }
      },
      day: {
        displayName: "Aŋpétu",
        relative: {
          0: "Lé aŋpétu kiŋ",
          1: "Híŋhaŋni kiŋháŋ",
          "-1": "Ȟtálehaŋ"
        },
        relativeTime: {
          future: {
            other: "Letáŋhaŋ {0}-čháŋ kiŋháŋ"
          },
          past: {
            other: "Hékta {0}-čháŋ k’uŋ héhaŋ"
          }
        }
      },
      "day-short": {
        displayName: "Aŋpétu",
        relative: {
          0: "Lé aŋpétu kiŋ",
          1: "Híŋhaŋni kiŋháŋ",
          "-1": "Ȟtálehaŋ"
        },
        relativeTime: {
          future: {
            other: "Letáŋhaŋ {0}-čháŋ kiŋháŋ"
          },
          past: {
            other: "Hékta {0}-čháŋ k’uŋ héhaŋ"
          }
        }
      },
      hour: {
        displayName: "Owápȟe",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            other: "Letáŋhaŋ owápȟe {0} kiŋháŋ"
          },
          past: {
            other: "Hékta owápȟe {0} kʼuŋ héhaŋ"
          }
        }
      },
      "hour-short": {
        displayName: "Owápȟe",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            other: "Letáŋhaŋ owápȟe {0} kiŋháŋ"
          },
          past: {
            other: "Hékta owápȟe {0} kʼuŋ héhaŋ"
          }
        }
      },
      minute: {
        displayName: "Owápȟe oȟʼáŋkȟo",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            other: "Letáŋhaŋ oȟ’áŋkȟo {0} kiŋháŋ"
          },
          past: {
            other: "Hékta oȟ’áŋkȟo {0} k’uŋ héhaŋ"
          }
        }
      },
      "minute-short": {
        displayName: "Owápȟe oȟʼáŋkȟo",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            other: "Letáŋhaŋ oȟ’áŋkȟo {0} kiŋháŋ"
          },
          past: {
            other: "Hékta oȟ’áŋkȟo {0} k’uŋ héhaŋ"
          }
        }
      },
      second: {
        displayName: "Okpí",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            other: "Letáŋhaŋ okpí {0} kiŋháŋ"
          },
          past: {
            other: "Hékta okpí {0} k’uŋ héhaŋ"
          }
        }
      },
      "second-short": {
        displayName: "Okpí",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            other: "Letáŋhaŋ okpí {0} kiŋháŋ"
          },
          past: {
            other: "Hékta okpí {0} k’uŋ héhaŋ"
          }
        }
      }
    }
  }];
});